// Capability profiles for tools - IDs match toolData.js (44 verified tools)
// Levels: 'exceptional' (rare), 'strong', 'moderate', 'limited', 'weak'

export const capabilityProfiles = {
  // ==================== LANGUAGE MODELS (1-7) ====================
  1: { // GPT-4
    'Output Quality': 'exceptional', 'Accuracy': 'strong', 'Speed': 'moderate',
    'Cost Efficiency': 'limited', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'moderate', 'Version Control': 'moderate',
  },
  2: { // Claude
    'Output Quality': 'exceptional', 'Accuracy': 'exceptional', 'Speed': 'moderate',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'exceptional', 'Multimodal': 'strong',
    'Enterprise Ready': 'exceptional', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },
  3: { // Gemini
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
    'Customization': 'moderate', 'Context Window': 'exceptional', 'Multimodal': 'exceptional',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'moderate', 'Version Control': 'limited',
  },
  4: { // LLaMA
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'limited', 'Integration Ease': 'limited',
    'Customization': 'exceptional', 'Context Window': 'moderate', 'Multimodal': 'limited',
    'Enterprise Ready': 'limited', 'Open Source': 'exceptional', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  5: { // Mistral
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'strong', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
    'Customization': 'strong', 'Context Window': 'moderate', 'Multimodal': 'limited',
    'Enterprise Ready': 'moderate', 'Open Source': 'strong', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },
  6: { // Cohere
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'limited',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },
  7: { // Command R+
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'exceptional', 'Multimodal': 'limited',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },

  // ==================== IMAGE GENERATION (8-9) ====================
  8: { // DALL-E
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'limited', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'weak',
    'Batch Processing': 'moderate', 'Version Control': 'limited',
  },
  9: { // Stable Diffusion
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
    'Customization': 'exceptional', 'Context Window': 'limited', 'Multimodal': 'moderate',
    'Enterprise Ready': 'limited', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== VIDEO GENERATION (10) ====================
  10: { // Sora
    'Output Quality': 'exceptional', 'Accuracy': 'moderate', 'Speed': 'limited',
    'Cost Efficiency': 'limited', 'API Robustness': 'moderate', 'Integration Ease': 'limited',
    'Customization': 'moderate', 'Context Window': 'limited', 'Multimodal': 'exceptional',
    'Enterprise Ready': 'limited', 'Open Source': 'weak', 'Streaming': 'weak',
    'Batch Processing': 'limited', 'Version Control': 'limited',
  },

  // ==================== AUDIO/VOICE (11) ====================
  11: { // ElevenLabs
    'Output Quality': 'exceptional', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'limited', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'exceptional',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },

  // ==================== SPEECH RECOGNITION (12) ====================
  12: { // Whisper
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'limited', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== CODE ASSISTANT (13-14) ====================
  13: { // GitHub Copilot
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'limited',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'limited', 'Version Control': 'moderate',
  },
  14: { // Cursor
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'exceptional', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'limited', 'Version Control': 'moderate',
  },

  // ==================== SEARCH (15) ====================
  15: { // Perplexity
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
    'Customization': 'limited', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'limited', 'Version Control': 'limited',
  },

  // ==================== ORCHESTRATION (16-19) ====================
  16: { // LangChain
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  17: { // LlamaIndex
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  18: { // Haystack
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  19: { // Semantic Kernel
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'strong',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== AGENTS (20-23) ====================
  20: { // AutoGen
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
    'Customization': 'exceptional', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  21: { // CrewAI
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  22: { // GPTs
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'limited', 'Version Control': 'moderate',
  },
  23: { // n8n AI
    'Output Quality': 'moderate', 'Accuracy': 'moderate', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'exceptional', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== VECTOR DATABASE (24-29) ====================
  24: { // Pinecone
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'moderate', 'API Robustness': 'exceptional', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'exceptional', 'Open Source': 'weak', 'Streaming': 'moderate',
    'Batch Processing': 'exceptional', 'Version Control': 'moderate',
  },
  25: { // Weaviate
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  26: { // Qdrant
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'exceptional', 'Version Control': 'strong',
  },
  27: { // Milvus
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'moderate',
    'Customization': 'strong', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'exceptional', 'Version Control': 'strong',
  },
  28: { // Chroma
    'Output Quality': 'moderate', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'limited', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },
  29: { // PGVector
    'Output Quality': 'moderate', 'Accuracy': 'strong', 'Speed': 'moderate',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'moderate', 'Multimodal': 'limited',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'limited',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== OBSERVABILITY (30-31) ====================
  30: { // Langfuse
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  31: { // Weights & Biases
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'strong', 'Context Window': 'moderate', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'moderate', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'exceptional',
  },

  // ==================== EVALUATION (32) ====================
  32: { // Promptfoo
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'limited',
    'Batch Processing': 'exceptional', 'Version Control': 'strong',
  },

  // ==================== GUARDRAILS (33-34) ====================
  33: { // Guardrails AI
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'limited', 'Multimodal': 'limited',
    'Enterprise Ready': 'moderate', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },
  34: { // NeMo Guardrails
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'strong', 'Integration Ease': 'moderate',
    'Customization': 'strong', 'Context Window': 'moderate', 'Multimodal': 'limited',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== DEPLOYMENT (35-37) ====================
  35: { // Hugging Face
    'Output Quality': 'strong', 'Accuracy': 'moderate', 'Speed': 'moderate',
    'Cost Efficiency': 'strong', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'strong', 'Multimodal': 'exceptional',
    'Enterprise Ready': 'strong', 'Open Source': 'exceptional', 'Streaming': 'moderate',
    'Batch Processing': 'strong', 'Version Control': 'exceptional',
  },
  37: { // Modal
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'strong', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'exceptional', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'moderate', 'Streaming': 'strong',
    'Batch Processing': 'exceptional', 'Version Control': 'strong',
  },

  // ==================== DATA PROCESSING (38) ====================
  38: { // LlamaParse
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'moderate', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'moderate', 'Open Source': 'strong', 'Streaming': 'limited',
    'Batch Processing': 'exceptional', 'Version Control': 'moderate',
  },

  // ==================== EMBEDDINGS (39-40) ====================
  39: { // OpenAI Embeddings
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'limited', 'Context Window': 'moderate', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'limited',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },
  40: { // Cohere Embed
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'strong', 'API Robustness': 'strong', 'Integration Ease': 'strong',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'limited',
    'Batch Processing': 'strong', 'Version Control': 'moderate',
  },

  // ==================== FINE-TUNING (41-42) ====================
  42: { // Unsloth
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'exceptional',
    'Cost Efficiency': 'exceptional', 'API Robustness': 'limited', 'Integration Ease': 'moderate',
    'Customization': 'exceptional', 'Context Window': 'strong', 'Multimodal': 'moderate',
    'Enterprise Ready': 'limited', 'Open Source': 'exceptional', 'Streaming': 'limited',
    'Batch Processing': 'strong', 'Version Control': 'strong',
  },

  // ==================== OTHER (43-44) ====================
  43: { // Claude Artifacts
    'Output Quality': 'strong', 'Accuracy': 'strong', 'Speed': 'strong',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'strong', 'Open Source': 'weak', 'Streaming': 'strong',
    'Batch Processing': 'limited', 'Version Control': 'moderate',
  },
  44: { // ChatGPT Plugins
    'Output Quality': 'moderate', 'Accuracy': 'moderate', 'Speed': 'moderate',
    'Cost Efficiency': 'moderate', 'API Robustness': 'strong', 'Integration Ease': 'exceptional',
    'Customization': 'moderate', 'Context Window': 'strong', 'Multimodal': 'strong',
    'Enterprise Ready': 'moderate', 'Open Source': 'weak', 'Streaming': 'moderate',
    'Batch Processing': 'limited', 'Version Control': 'limited',
  },
};

// Default profile for tools without specific profiles
export const defaultProfile = {
  'Output Quality': 'moderate', 'Accuracy': 'moderate', 'Speed': 'moderate',
  'Cost Efficiency': 'moderate', 'API Robustness': 'moderate', 'Integration Ease': 'moderate',
  'Customization': 'moderate', 'Context Window': 'moderate', 'Multimodal': 'limited',
  'Enterprise Ready': 'moderate', 'Open Source': 'moderate', 'Streaming': 'moderate',
  'Batch Processing': 'moderate', 'Version Control': 'moderate',
};

// Level values for scoring
export const levelVal = { exceptional: 5, strong: 4, moderate: 3, limited: 2, weak: 1 };
export const levelMin = { exceptional: 5, strong: 4, moderate: 3, limited: 2, weak: 1 };
